import DonutChartWithPercent from './DonutChartWithPercent';

export default DonutChartWithPercent;
